import React, { Component } from 'react';
import Lottie from 'react-lottie';
import LoadingLottie from "../../src/Lotties/Loading.json";
import BuilderHome from '../components/BuilderHome.js'
import "../custom.css";

export class Home extends Component {
    state = {
        Loading: true,
        ListOfAllProducts: [],
        ListOfAddedProducts: [],
        FilteredListOfProducts: [],
        ListOfProductGroups: [],
        FilteredListOfProductGroups: [],
        ListOfProductCategories: [],
        PercentageFull: 0,
        FullLoads: 0,
        Error: false,
        ErrorMessage: 'An error has occurred receiving products',
        Title: 'Load Building'
    }

    componentDidMount() {
        this.GetProducts();

    }

    async GetProducts() {
        const response = await fetch('api/loadbuilding/getallproducts');

        if (response.ok) {
            const data = await response.json();
            this.setState({
                ListOfAllProducts: data,
                FilteredListOfProducts: data,
                Error: false
            });

            this.GetProductGroups();
            this.GetProductCategories();
        }
        else {

            setTimeout(() => {
                this.setState({
                    Loading: false,
                    Error: true
                });
            }, 1000)
        }


    }

    async GetProductGroups() {
        const response = await fetch('api/loadbuilding/getproductgroups');

        if (response.ok) {
            const data = await response.json();
            this.setState({
                ListOfProductGroups: data,
                FilteredListOfProductGroups: data,
                Error: false
            });

            //3second delay to show loading lottie
            setTimeout(() => {
                this.setState({ Loading: false });
            }, 3000);

        }
        else {

            setTimeout(() => {
                this.setState({
                    Loading: false,
                    Error: true
                });
            }, 1000)
        }

    }

    async GetProductCategories() {
        const response = await fetch('api/loadbuilding/getproductcategories');

        if (response.ok) {
            const data = await response.json();
            this.setState({
                ListOfProductCategories: data,
                Error: false
            });

            //3second delay to show loading lottie
            setTimeout(() => {
                this.setState({ Loading: false });
            }, 3000);

        }
        else {

            setTimeout(() => {
                this.setState({
                    Loading: false,
                    Error: true
                });
            }, 1000)
        }


    }

    UpdateFilteredList = (productGrpId, productCatId) => {

        if (productGrpId === "") {

            //check product cat id and if it is not empty populate products based on product cat

            if (productCatId === null || productCatId === "") {
                this.setState({ FilteredListOfProducts: this.state.ListOfAllProducts });
            }
            else {
                const updatedProductList = this.state.ListOfAllProducts.filter(item => item.productCatId === productCatId);
                this.setState({ FilteredListOfProducts: updatedProductList });
            }


        }
        else {
            const updated = this.state.ListOfAllProducts.filter(item => item.productGroupId === productGrpId);
            this.setState({ FilteredListOfProducts: updated });
        }

    }

    UpdateFilteredProductGroupList = (productCatId) => {
        
        if (productCatId === "") {
            this.setState({
                FilteredListOfProductGroups: this.state.ListOfProductGroups,
                FilteredListOfProducts: this.state.ListOfAllProducts
            });
        }
        else {

            const updated = this.state.ListOfProductGroups.filter(item => item.productCatId === productCatId);

            const updatedProductList = this.state.ListOfAllProducts.filter(item => item.productCatId === productCatId);

            this.setState({
                FilteredListOfProductGroups: updated,
                FilteredListOfProducts: updatedProductList
            });


        }
    }

    ResetFilteredList = () => {
        this.setState({
            FilteredListOfProducts: this.state.ListOfAllProducts,
            FilteredListOfProductGroups: this.state.ListOfProductGroups
        });
    }

    AddProductToTable = async (xrefId, qty) => {

        const xRefInt = parseInt(xrefId);
        const qtyInt = parseInt(qty);

        this.Add(xRefInt, qtyInt);
    }

    async Add(xrefId, qty) {

        let response = await fetch('api/loadbuilding/addproduct/', {
            method: 'post',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                XrefId: xrefId,
                Quantity: qty,
                ProductList: this.state.ListOfAllProducts,
                AddedProducts: this.state.ListOfAddedProducts,
                FullLoads: this.state.FullLoads,
                PercentageFull: this.state.PercentageFull
            })
        })
            .then(res => res.json())
            .catch();

        this.setState({ ListOfAddedProducts: response.addedProducts }, () => {
        });

        //call method now to API to calculate capacity
        this.CalculateWeight(this.state.ListOfAddedProducts);

    }

    UpdateQtyChange = async (value, index) => {

        let ListOfAddedProducts = [...this.state.ListOfAddedProducts];
        let option = { ...ListOfAddedProducts[index] };
        option.quantity = parseInt(value);

        //const xrefId = parseInt(option.xrefId);

        ListOfAddedProducts[index] = option;
        this.setState({ ListOfAddedProducts }, () => {
        });

        //call method now to API to calculate capacity

        this.CalculateWeight(ListOfAddedProducts);


    }

    RemoveProductRow = async (index, xrefId) => {

        const ListOfAddedProducts = [...this.state.ListOfAddedProducts];
        ListOfAddedProducts.splice(index, 1);

        this.setState({ ListOfAddedProducts }, () => {
        });

        //call method now to API to calculate capacity

        this.CalculateWeight(ListOfAddedProducts);

    }

    async CalculateWeight(ListOfAddedProducts) {
        let response = await fetch('api/loadbuilding/calculateweight/', {
            method: 'post',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                AddedProducts: ListOfAddedProducts,
                FullLoads: this.state.FullLoads,
                PercentageFull: this.state.PercentageFull
            })
        })
            .then(res => res.json())
            .catch();


        this.setState({
            PercentageFull: response.percentageFull,
            FullLoads: response.fullLoads
        }, () => {
        });

    }

    render() {

        if (this.state.Loading) {

            const lottieLoading = {
                loop: true,
                autoplay: true,
                animationData: LoadingLottie,
                rendererSettings: {
                    preserveAspectRatio: 'xMidYMid slice'
                }
            };

            return (<div>
                <br />
                <Lottie options={lottieLoading}
                    height={600}
                    width={600}
                    isStopped={false}
                    isPaused={false}
                >
                </Lottie>
                <br />

            </div>)
        }

        if (this.state.Error) {
            return (<div className="errorMessage">
                <h1>{this.state.ErrorMessage}</h1>
            </div>);

        };

        return (
            <div>
                <h1>{this.state.Title}</h1>
                <BuilderHome
                    ListOfAddedProducts={this.state.ListOfAddedProducts}
                    FilteredListOfProducts={this.state.FilteredListOfProducts}
                    ListOfProductGroups={this.state.FilteredListOfProductGroups}
                    UpdateFilteredList={this.UpdateFilteredList}
                    AddProductToTable={this.AddProductToTable}
                    UpdateQtyChange={this.UpdateQtyChange}
                    ResetFilteredList={this.ResetFilteredList}
                    RemoveProductRow={this.RemoveProductRow}
                    PercentageFull={this.state.PercentageFull}
                    FullLoads={this.state.FullLoads}
                    ListOfProductCategories={this.state.ListOfProductCategories}
                    UpdateFilteredProductGroupList={this.UpdateFilteredProductGroupList}
                />
            </div>
        );
    }
}
